export default __webpack_public_path__ + "static/media/pano.0cb0c2c0.jpg";